import React, { useEffect, useState } from "react"
import * as routes from "../../Router/RoutesURL";
import { useSearchParams } from "react-router-dom";
import AppContainer from "../../components/AppContainer/AppContainer"
import { Tab, Tabs } from "react-bootstrap";
import GuestDinacharyaTable from "./GuestDinacharya/GuestDinacharya";
import ProgramFeedbacksTable from "./ProgramFeedbacks/ProgramFeedbacks";
import TestinomialsTable from "./Testimonials/Testimonials";
import "./ReportsDashboard.scss"
import { getPermissionByAppName } from "../../utils/Helper";
// import ConsultantRatingsTable from "./ConsultantRatings/ConsultantRatings";
// import GuestCommentsTable from "./GuestComment/GuestComments";
import QMSScoreboardTable from "./QMSScoreboard/QMSScoreboard";
import GuestCommentsTable from "./GuestComment/GuestComments";
import ConsultantRatingsTable from "./ConsultantRatings/ConsultantRatings";
import QMSFeedbackDetailsTable from "./QMSFeedbackDetails/QMSFeedbackDetails";
import TherapistNotes from "./TherapistNotes/TherapistNotes";
import { tabKeys } from "../../Config/Constant";

const REPORT_TABS = [
    {
      key: tabKeys.reports.PROGRAM_FEEDBACK,
      title: "Program Feedbacks",
      Component: ProgramFeedbacksTable,
    },
    {
      key: tabKeys.reports.TESTIMONIALS,
      title: tabKeys.reports.TESTIMONIALS,
      Component: TestinomialsTable,
      permissionKey: "Reports",
    },
    {
      key: tabKeys.reports.QMS_SCORECARD,
      title: tabKeys.reports.QMS_SCORECARD,
      Component: QMSScoreboardTable,
      unmountOnExit: true,
    },
    {
      key: tabKeys.reports.QMS_FEEDBACK_REPORT,
      title: tabKeys.reports.QMS_FEEDBACK_REPORT,
      Component: QMSFeedbackDetailsTable,
    },
    {
      key: tabKeys.reports.GUEST_COMMENTS,
      title: tabKeys.reports.GUEST_COMMENTS,
      Component: GuestCommentsTable,
    },
    {
      key: tabKeys.reports.CONSULTANT_RATINGS,
      title: tabKeys.reports.CONSULTANT_RATINGS,
      Component: ConsultantRatingsTable,
    },
    {
      key: tabKeys.reports.THERAPIST_SESSIONS,
      title: tabKeys.reports.THERAPIST_SESSIONS,
      Component: TherapistNotes,
    },
  ];
  

const ReportsDashboard = (props) => {
    const { history } = props;
    const [activeTab, setActiveTab] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();

    const handleTabSelect = (index) => {
        if(index!==activeTab){
            const newParams = new URLSearchParams();
            newParams.set("tab", index);
            setSearchParams(newParams);
            setActiveTab(index);
        }
    };

    useEffect(() => {
        const tab = searchParams.get("tab");
        if (tab) {
            setActiveTab(tab);
        } else {
            let defaultTab = tabKeys.reports.PROGRAM_FEEDBACK;
            setActiveTab(defaultTab);
        }
    }, [searchParams]);

    return (
        <AppContainer history={history}>
            <div className="event-table reports-table">
                <div className="ReportsContainer">
                    
                <Tabs
                id="controlled-tab-example"
                    className="TabsDiv"
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                    >
                    {REPORT_TABS.map(
                        ({ key, title, Component, permissionKey, unmountOnExit }) => {
                        const permission = permissionKey
                            ? getPermissionByAppName(permissionKey)
                            : null;

                        if (permissionKey && permission === "hide") return null;

                        return (
                            <Tab
                                key={key}
                                eventKey={key}
                                title={title}
                                unmountOnExit={unmountOnExit}
                                >
                                {activeTab === key && (
                                    <Component
                                    activeTab={activeTab}
                                    {...(permissionKey ? { permission } : {})}
                                    />
                                )}
                            </Tab>
                        );
                        }
                    )}
                    </Tabs>

                </div>
            </div>
        </AppContainer >
    )
}

export default ReportsDashboard
